import { useState, useCallback } from "react";
import { generateRequestId } from "../utils/RequestIdGenerator";
import { axiosInititateDownloadReportInstance } from "../services/AxiosIntercepter";
import { ApiType } from "../services/ApiTags";
import { getFromLocalStorage } from "../utils/localStorageUtils";
import { LOGIN_ID, SESSION_ID, USER_NAME } from "../constants/LocalStorageKeyValuePairString";

const useAxiosHookForDownloadReportInitiate = () => {
  const [downloadedDataFromInitiateApi, setDownloadedData] = useState(null);
  const [downloadInitiateApiError, setApiCallError] = useState(null);
  const [showProgressBarForDownloadInitiate, setProgressBar] = useState(false);

  const fetchDataFromDownloadInitiate = useCallback(
    async (
      url,
      apiType,
      method = ApiType.POST_METHOD,
      encryptedData = null,
      options = {},
      callback
    ) => {
      // show progress bar
      setProgressBar(true);

      let requestData = {};
  
        // set common request content
        requestData = {
          requestId: generateRequestId(),
          loginId:getFromLocalStorage(LOGIN_ID),
          sessionId:getFromLocalStorage(SESSION_ID),
          contentData: encryptedData,
          loginUserName:getFromLocalStorage(USER_NAME)
        };

      try {
        const response = await axiosInititateDownloadReportInstance({
          url,
          method,
          data: requestData,
          ...options,
        });
        setDownloadedData(response.data);
        if (callback) {
          callback(response.data);
        }
      } catch (error) {
        // show error
        setApiCallError(error);
      } finally {
        // hide progress bar
        setProgressBar(false);
      }
    },
    []
  );

  return { downloadedDataFromInitiateApi, downloadInitiateApiError, showProgressBarForDownloadInitiate, fetchDataFromDownloadInitiate };
};

export default useAxiosHookForDownloadReportInitiate;
